let shopifyLocale = Shopify.locale.split("-")[0];
let localeCountry = `${shopifyLocale}-${Shopify.country}`;
const shopCurrency = Shopify.currency.active;
function currencyES6Format(money) {
  return new Intl.NumberFormat(localeCountry, {
    style: "currency",
    currency: shopCurrency,
  }).format(money);
}
var hostname = window.location.hostname;
var link = `https://${hostname}/cart.json`;

async function getData() {
  let x = await fetch(link);
  const data = await x.json();
  return data;
}
var dropdowncart = () => {
  $(".checkout_btn").text("Checkout");
  $("#cart_drawer").addClass("loader");
  // $('.custom-cart-error').remove()
  getData().then((data) => {
    console.log(data, "bssssvsssssssssssss");
    $("#cart_drawer").removeClass("loader");
    var item_count = data["item_count"];
    var total_price = data["total_price"] / 100;
    var product_count = data["items"].length;
    //console.log(data["items"]);
    $(".custom_cart_count").html(item_count);
    $(".site-header-cart--count").attr("data-header-cart-count", item_count);
    if (item_count > 0) {
      $(".minitotal.total,.sd_sidebar_check").show();
      $("#productbox").find("div").remove();
      $("#productbox").html(
        $('<h3 class="heading" id="cart_item_count"></h3>')
      );
      for (var i = 0; i < product_count; i++) {
        var item_id = data["items"][i]["id"];
        var product_title = data["items"][i]["product_title"];
        var product_handle = data["items"][i]["handle"];
        var quantity = data["items"][i]["quantity"];
        var line_price = data["items"][i]["price"] / 100;
        var url = data["items"][i]["url"];
        var image_url = data["items"][i]["image"];
        var variants = data["items"][i]["variant_options"];
        var product_key = data["items"][i]["key"];
        //console.log(variants);
        var variant_title = data["items"][i]["variant_title"];
        //console.log(variant_title);
        if (variant_title == null) {
          variant_title = "";
        }

        $("#cart_item_count").text(+item_count + " Items in your cart");
        $("#mini_cart_total").text(currencyES6Format(total_price.toFixed(2)));
        $("#productbox").append(
          $(
            '<div class="product-inner row mini-cart-product" id="' +
              item_id +
              '"><div class="product_image image"><a href="javascript:void(0);"><img src="' +
              image_url +
              '" alt="' +
              product_title +
              '"></a></div><div class="pro-content" id="pro-content"><div class="cartproname prohead"><h3 class="product_title m-0"><a href="' +
              url +
              '" style="color: rgb(51, 51, 51);" id="product_head">' +
              product_title +
              ' </a></h3><div class="prd_variant_style">' +
              variant_title +
              '</div></div><div class="pro-quantity"><div class="quantity-selector"><span class="price product_price" id="product_price" style="color: #186fbb">' +
              currencyES6Format(line_price.toFixed(2)) +
              '<span class="quantitybox"><button type="button" class="sd_altera sminus" href="https://' +
              hostname +
              '/cart/change?line=1&amp;quantity=0" rel="' +
              i +
              '">-</button><input type="text" readonly id="updatequant" name="updatequant" value="' +
              quantity +
              '" proid="' +
              item_id +
              '" prokey="' +
              i +
              '"><button type="button" class="sd_altera splus down">+</button></span><span class="product_price" style="color: rgb(253, 90, 0);"> </span><p class="removeproduct remove" id="' +
              product_key +
              '" href="https://' +
              hostname +
              '/cart/change?line=1&amp;quantity=0" rel="' +
              i +
              '">Remove</p></div></div></div></div>'
          )
        );
      }
      $(".cart-dis-txt").show();
      $(".remove").on("click", function remove_item() {
        let product_id = this.id;
        $(this).parents(".product-inner").remove();
        removecart(product_id);
      });
      $(".splus").on("click", function () {
        var upinput = $(this).parents(".quantitybox").find("input").val();
        var inc = parseInt(upinput) + 1;
        $(this).parents(".quantitybox").find("input").val(inc);
        var inc_id = $(this)
          .parents(".quantitybox")
          .find("input")
          .attr("proid");
        incr_cart(inc_id, inc);
      });
      $(".sminus").on("click", function () {
        var upinput = $(this).parents(".quantitybox").find("input").val();
        var dec = parseInt(upinput) - 1;
        var dec_id = $(this)
          .parents(".quantitybox")
          .find("input")
          .attr("proid");
        $(this).parents(".quantitybox").find("input").val(dec);
        dec_cart(dec_id, dec);
      });
    } else {
      $(".cart-dis-txt").hide();
      $("#productbox").html(
        $(
          `<div class="cart-item-container">
    <div class="media-body empty-media">
      <figure>
        <img src="https://cdn.shopify.com/s/files/1/0832/8521/3505/files/empty-cart.webp?v=1698652243" alt="empty-cart">
      </figure>
      <h3 class="row mini-cart-product">Add items to bag now</h3>
    </div>
    <div class="bottom-cart-box">
      <div class="cart-btn-container">
        <a href="https://${hostname}/" class="primary-btn cont-shopping sd_shopproduct" style="display: block;">Shop</a>
      </div>
    </div>
  </div>`
        )
      );
      $(".minitotal.total,.sd_sidebar_check").hide();
    }
  });
};

var addToCart = (form) => {
  // $.post('/cart/add.js', $(form).serialize()).fail(function(error) {
  //   var errorText = JSON.parse(error.responseText);
  //   console.log(errorText);
  //   dropdowncart();
  //   // $('.custom-cart-error').remove();
  //   // $('.custom-cart .product-outer').prepend('<p class="custom-cart-error">' + errorText.description + '</p>');
  // }).then(function(){
  //   dropdowncart();
  // });
  setTimeout(function () {
    dropdowncart();
  }, 500);
};

//custom cart
//$('form[action="/cart/add"]').on('submit',function(e){
$(document).on("submit", 'form[action="/cart/add"]', function (e) {
  addToCart(this);
  e.preventDefault();
  e.stopPropagation();
  $("#cart_drawer").addClass("active");
});

// setTimeout(function () {

// var addtocart = document.querySelectorAll('button.productitem--action-trigger.productitem--action-atc.button-primary.mdc-ripple-surface.mdc-ripple-upgraded');
// 0
// var removeClick = () => { };

// for (let i = 0; i < addtocart.length; i++) {
//   addtocart[i].removeEventListener("click", removeClick);
// }
$(
  "button.productitem--action-trigger.productitem--action-atc.button-primary.mdc-ripple-surface.mdc-ripple-upgraded"
).off("click");

//,function () {
$(document).on("click", ".atc--button", function (e) {
  //.atc--button,.productitem--action-atc
  $(".modal--quickshop-full .modal-close").click();
  // Do something with $(this).
  let cart = {
    id: $(this).data("variant-id"),
    quantity: 1,
  };
  //console.log(cart);
  $.post("/cart/add.js", cart)
    .fail(function (error) {
      var errorText = JSON.parse(error.responseText);
      //console.log(errorText);
      dropdowncart();
      $("#cart_drawer").addClass("active");
    })
    .then(function () {
      //console.log("in then");
      $(".modal--quickshop-slim .modal-close").trigger("click");
      dropdowncart();
      $("#cart_drawer").addClass("active");
    });
  e.preventDefault();
  e.stopPropagation();
});
// },100);

var update_header_cart = () => {
  getData().then((data) => {
    var item_count = data["item_count"];
    $(".custom_cart_count").html(item_count);
  });
};
update_header_cart();

$(".site-header-cart--button").on("click", function (e) {
  e.preventDefault();
  dropdowncart();
  $("#cart_drawer").addClass("active");
});

var incr_cart = (proid, inc) => {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(proid),
      quantity: inc,
    },
  }).then((data) => {
    dropdowncart();
  });
};
var dec_cart = (proid, dec) => {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(proid),
      quantity: dec,
    },
  }).then((data) => {
    dropdowncart();
  });
};

var removecart = (new_id) => {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(new_id),
      quantity: 0,
    },
  }).then((data) => {
    dropdowncart();
  });
};
$(document).on("click", ".sides_cross_image", function (e) {
  $("#cart_drawer").removeClass("active");
});

/* ============================================================
   FINAL PRODUCT SUGGESTION ENGINE (Newest First, Max 8)
   ============================================================ */

let lastAddedProductHandle = localStorage.getItem("last_added_handle") || null;
let suggestedHandles = JSON.parse(
  localStorage.getItem("suggested_handles") || "[]"
);
const maxSuggestions = 8;
let isLoadingSuggestions = false;

/* ============================================================
   1. Restore saved suggestions on page load
   ============================================================ */
document.addEventListener("DOMContentLoaded", renderSavedSuggestions);

async function renderSavedSuggestions() {
  const container = document.getElementById("suggestion-container");
  const header = document.querySelector(".suggestion-modal .modal-header");

  if (!container) return;

  if (!suggestedHandles.length) {
    container.innerHTML = "";
    if (header) header.style.display = "none";
    return;
  }

  if (header) header.style.display = "block";

  container.innerHTML = "";

  // NEWEST FIRST (SAVED)
  for (const handle of suggestedHandles) {
    await appendSingleSavedSuggestion(handle);
  }
}

/* ============================================================
   2. Append a single saved suggestion (used on refresh)
   ============================================================ */
async function appendSingleSavedSuggestion(handle) {
  const container = document.getElementById("suggestion-container");
  if (!container) return;

  if (container.children.length >= maxSuggestions) return;
  if (container.querySelector(`[data-related-handle="${handle}"]`)) return;

  try {
    const res = await fetch(`/products/${handle}.json`);
    const data = await res.json();
    const product = data.product;
    if (!product?.variants?.length) return;

    const variantId = product.variants[0].id;
    const image = product.images?.[0]?.src || "";
    const title = product.title;
    const price = product.variants[0].price;

    const card = `
      <div class="suggestion-card" data-related-handle="${handle}">
        <div class="card-inner">
          <img src="${image}" alt="${title}" width="100" height="100">
          <div class="card-content">
            <h3 class="title">${title}</h3>
            <p class="price">${formatMoney(price)}</p>
            <div class="btn-wrapper">
              <button class="add-to-cart addToCart" data-variant-id="${variantId}">
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // NEWEST AT TOP
    container.insertAdjacentHTML("afterbegin", card);
  } catch {}
}

/* ============================================================
   3. Load related products when new product is added
   ============================================================ */
async function loadRelatedProductsDynamic() {
  if (isLoadingSuggestions) return;
  isLoadingSuggestions = true;

  const container = document.getElementById("suggestion-container");
  const header = document.querySelector(".suggestion-modal .modal-header");
  if (!container) {
    isLoadingSuggestions = false;
    return;
  }

  // If cart empty → clear suggestions completely
  const cart = await fetch("/cart.js").then((r) => r.json());
  if (!cart.items.length) {
    suggestedHandles = [];
    localStorage.removeItem("suggested_handles");
    container.innerHTML = "";
    if (header) header.style.display = "none";
    isLoadingSuggestions = false;
    return;
  }

  if (!lastAddedProductHandle) {
    isLoadingSuggestions = false;
    return;
  }

  // Fetch full product JSON of recently added item
  const productRes = await fetch(`/products/${lastAddedProductHandle}.json`);
  const productData = await productRes.json();
  const product = productData.product;
  if (!product) {
    isLoadingSuggestions = false;
    return;
  }

  const tagsArray = product.tags.split(",").map((t) => t.trim());
  const classTag = tagsArray.find((t) => t.includes("class-"));

  // Build Search Query: class-X OR all
  let searchQuery = "";
  if (classTag) searchQuery += `${classTag} OR `;
  searchQuery += "all";

  // Fetch related results
  const searchUrl = `/search/suggest.json?q=${encodeURIComponent(
    searchQuery
  )}&resources[type]=product&resources[limit]=20`;
  const searchRes = await fetch(searchUrl);
  const searchData = await searchRes.json();
  const rawResults = searchData?.resources?.results?.products || [];

  // Filter: unique, not same, not already shown
  const fresh = rawResults
    .filter((item) => item.handle !== product.handle)
    .filter((item) => !suggestedHandles.includes(item.handle))
    .slice(0, 2);

  if (!fresh.length) {
    isLoadingSuggestions = false;
    return;
  }

  /* ------------------------------------------
     INSERT NEWEST AT TOP (unshift)
     Remove oldest when exceeds maxSuggestions
     ------------------------------------------ */

  fresh.reverse().forEach((item) => {
    suggestedHandles.unshift(item.handle);
  });

  if (suggestedHandles.length > maxSuggestions) {
    suggestedHandles = suggestedHandles.slice(0, maxSuggestions);
  }

  localStorage.setItem("suggested_handles", JSON.stringify(suggestedHandles));

  // Show header
  if (header) header.style.display = "block";

  // Append new cards
  await appendRelatedProductCards(fresh);

  isLoadingSuggestions = false;
}

/* ============================================================
   4. Append NEW suggestions (when Add To Cart clicked)
   ============================================================ */
async function appendRelatedProductCards(products) {
  const container = document.getElementById("suggestion-container");
  if (!container) return;

  for (const p of products) {
    if (container.children.length >= maxSuggestions) return;
    if (container.querySelector(`[data-related-handle="${p.handle}"]`))
      continue;

    try {
      const fullRes = await fetch(`/products/${p.handle}.json`);
      const fullData = await fullRes.json();
      const fullProduct = fullData.product;

      if (!fullProduct?.variants?.length) continue;

      const variantId = fullProduct.variants[0].id;

      const card = `
        <div class="suggestion-card" data-related-handle="${p.handle}">
          <div class="card-inner">
            <img src="${p.image}" alt="${p.title}" width="100" height="100">
            <div class="card-content">
              <h3 class="title">${p.title}</h3>
            <p class="price">₹ ${Number(p.price).toFixed(2)}</p>

              <div class="btn-wrapper">
                <button class="add-to-cart addToCart" data-variant-id="${variantId}">
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      `;

      // New suggestions always added at TOP
      container.insertAdjacentHTML("afterbegin", card);
    } catch {}
  }
}

/* ============================================================
   5. INR Format Helper
   ============================================================ */
function formatMoney(amount) {
  try {
    amount = amount;
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(amount);
  } catch {
    return amount;
  }
}
